import MainLayouts from '../../layout/MainLayouts'
import WhyChooseUs from './WhyChooseUs'
import TopCourses from './TopCourses'
import HeroSection from './HeroSection'
import WhoItIsFor from './WhoItIsFor'
import TrainTeam from './TrainTeam'
import Trainers from './Trainers'
import Testimonial from './Testimonial'
import TrustedBy from './TrustedBy'

export default function Consultancy() {
  return (
    <MainLayouts>
        <HeroSection/>
        <WhyChooseUs/>
        <TopCourses/>
        <TrustedBy/>
        <WhoItIsFor/>
        <TrainTeam/>
        <Trainers/>  
       <Testimonial/>
    </MainLayouts>
    
  )
}
